// tpo-20261103: TPO (market profile) computation for FootprintChartCanvas's
// 'tpo' chart type. Pure: takes the chart's own candles; the canvas does the
// render in its existing coordinate system.
export const TPO_PERIOD_MS = 1800000
export const TPO_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwx'

const _etFmt = typeof Intl !== 'undefined'
  ? new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' })
  : null
// Daily session key: crypto = UTC day; stocks = New York day; CME = NY day rolled at 18:00 ET.
export function tpoSessionKey(t, kind) {
  if (kind === 'crypto' || !_etFmt) return new Date(t).toISOString().slice(0, 10)
  return _etFmt.format(new Date(kind === 'cme' ? t + 6 * 3600000 : t))
}

export function tpoNiceStep(raw) {
  if (!(raw > 0)) return 0
  const e = Math.pow(10, Math.floor(Math.log10(raw)))
  for (const m of [1, 2, 2.5, 5, 10]) if (m * e >= raw - 1e-12) return m * e
  return 10 * e
}

// Profile for candles[i0..i1] (one session). rs = price per row.
export function tpoBuildProfile(candles, i0, i1, rs) {
  const t0 = candles[i0].startTime
  const rows = new Map()
  let tot = 0, hi = -Infinity, lo = Infinity, ibHi = -Infinity, ibLo = Infinity
  for (let i = i0; i <= i1; i++) {
    const c = candles[i]
    if (!c || !(c.high_mcap > 0)) continue
    const pi = Math.min(TPO_LETTERS.length - 1, Math.max(0, Math.floor((c.startTime - t0) / TPO_PERIOD_MS)))
    const a = Math.floor(c.low_mcap / rs + 1e-9), b = Math.floor(c.high_mcap / rs + 1e-9)
    for (let r = a; r <= b; r++) {
      let L = rows.get(r); if (!L) { L = []; rows.set(r, L) }
      if (L[L.length - 1] !== pi) { L.push(pi); tot++ }
    }
    if (c.high_mcap > hi) hi = c.high_mcap
    if (c.low_mcap < lo) lo = c.low_mcap
    if (pi <= 1) { ibHi = Math.max(ibHi, c.high_mcap); ibLo = Math.min(ibLo, c.low_mcap) }
  }
  if (!tot) return null
  const keys = [...rows.keys()].sort((x, y) => x - y)
  const kLo = keys[0], kHi = keys[keys.length - 1], mid = (kLo + kHi) / 2
  const n = (r) => rows.get(r)?.length || 0
  // POC: most TPOs; ties -> closest to the centre of the session range.
  let poc = kLo
  for (const r of keys) if (n(r) > n(poc) || (n(r) === n(poc) && Math.abs(r - mid) < Math.abs(poc - mid))) poc = r
  // 70% value area, expanded two rows at a time toward the larger side.
  let vaHi = poc, vaLo = poc, acc = n(poc)
  while (acc < tot * 0.7 && (vaHi < kHi || vaLo > kLo)) {
    const up = vaHi < kHi ? n(vaHi + 1) + n(vaHi + 2) : -1
    const dn = vaLo > kLo ? n(vaLo - 1) + n(vaLo - 2) : -1
    if (up >= dn) { acc += up; vaHi = Math.min(vaHi + 2, kHi) } else { acc += dn; vaLo = Math.max(vaLo - 2, kLo) }
  }
  return { rows, keys, poc, vaHi, vaLo, tot, hi, lo, ibHi, ibLo, rs }
}
